export const I18nId = {
  Login: 'Login',
  PleaseLoginToContinue: 'PleaseLoginToContinue',
  PleaseInputTextToConfirmDelete: 'PleaseInputTextToConfirmDelete',
  Delete: 'Delete',
  Apply: 'Apply',
  ApplyAndSendEmail: 'ApplyAndSendEmail',
  Back: 'Back',
  Cancel: 'Cancel',
  PleaseInputText: 'PleaseInputText',
  Oops: 'Oops',
  SelectImage: 'SelectImage',
  Unconfirmed: 'Unconfirmed',
  MemberDetail: 'MemberDetail',
  Home: 'Home',
  Dashboard: 'Dashboard',
  Member: 'Member',
  Members: 'Members',
  GlobalStyle: 'GlobalStyle',
  GlobalStyles: 'GlobalStyles',
  NewStyle: 'NewStyle',
  StyleDetail: 'StyleDetail',
  Page: 'Page',
  PageBuilders: 'PageBuilders',
  NewPage: 'NewPage',
  PageDetail: 'PageDetail',
  SectionEditor: 'SectionEditor',
  SectionBuilder: 'SectionBuilder',
  SectionBuilders: 'SectionBuilders',
  NewSection: 'NewSection',
  SectionDetail: 'SectionDetail',
  Email: 'Email',
  EmailBuilder: 'EmailBuilder',
  EmailBuilders: 'EmailBuilders',
  NewEmail: 'NewEmail',
  EmailDetail: 'EmailDetail',
  CourseCategory: 'CourseCategory',
  CourseCategories: 'CourseCategories',
  NewCourseCategory: 'NewCourseCategory',
  DetailCourseCategory: 'CourseCategoryDetail',
  CourseOrder: 'CourseOrder',
  CourseOrders: 'CourseOrders',
  NewCourseOrder: 'NewCourseOrder',
  CourseOrderDetail: 'CourseOrderDetail',
  CourseCalendar: 'CourseCalendar',
  CourseTeacher: 'CourseTeacher',
  CourseTeachers: 'CourseTeachers',
  NewCourseTeacher: 'NewCourseTeacher',
  CourseTeacherDetail: 'CourseTeacherDetail',
  Course: 'Course',
  Courses: 'Courses',
  NewCourse: 'NewCourse',
  CourseDetail: 'CourseDetail',
  ProductCategory: 'ProductCategory',
  ProductCategories: 'ProductCategories',
  NewProductCategory: 'NewProductCategory',
  ProductCategoryDetail: 'ProductCategoryDetail',
  Product: 'Product',
  Products: 'Products',
  NewProduct: 'NewProduct',
  ProductDetail: 'ProductDetail',
  ProductShipping: 'ProductShipping',
  ProductShippings: 'ProductShippings',
  NewProductShipping: 'NewProductShipping',
  ProductShippingDetail: 'ProductShippingDetail',
  ProductCoupon: 'ProductCoupon',
  ProductCoupons: 'ProductCoupons',
  NewProductCoupon: 'NewProductCoupon',
  ProductCouponDetail: 'ProductCouponDetail',
  ProductOrder: 'ProductOrder',
  ProductOrders: 'ProductOrders',
  ProductOrderDetail: 'ProductOrderDetail',
  Image: 'Image',
  Images: 'Images',
  Component: 'Component',
  TotalRows: 'TotalRows',
  Search: 'Search',
  NoItemsAvailable: 'NoItemsAvailable',
  NoFilteredResultsAvailable: 'NoFilteredResultsAvailable',
  Backoffice: 'Backoffice',
  NewBoMember: 'NewBoMember',
  BoMember: 'BoMember',
  BoMembers: 'BoMembers',
  SaveDraft: 'SaveDraft',
  Deploy: 'Deploy',
  DiscardChange: 'DiscardChange',
  BlogCategory: 'BlogCategory',
  BlogCategories: 'BlogCategories',
  NewBlogCategory: 'NewBlogCategory',
  DetailBlogCategory: 'BlogCategoryDetail',
  Blog: 'Blog',
  Blogs: 'Blogs',
  NewBlog: 'NewBlog',
  BlogDetail: 'BlogDetail',
  Link: 'Link',
  Title: 'Title',
  Preview: 'Preview',
  Edit: 'Edit',
}

export const ModuleId = {
  BoMember: 'bo_member',
  PageBuilder: 'page_builder',
  PageBuilderEditor: 'page_builder_editor',
  Member: 'member',
  Course: 'course',
  CourseOrder: 'course_order',
  Product: 'product',
  ProductOrder: 'product_order',
  EmailBuilder: 'email_builder',
  Image: 'image',
  Blog: 'blog',
}